import * as Sentry from '@sentry/react';

/**
 * Log an unexpected error and send it to Sentry.
 *
 * Axios errors are skipped for Sentry: 5xx/network ones are already sent by
 * the response interceptor (Service/api.js), and 4xx are business responses,
 * not bugs — so no duplicates and no noise.
 */
export function reportError(err, context) {
    console.error(err, context ?? '');
    if (err && err.isAxiosError) return;
    Sentry.captureException(err, context ? { extra: context } : undefined);
}

export default reportError;
